import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export type BirthdayStatusFilter = 'all' | 'active' | 'inactive';

interface ReportingBirthdaysParams {
  // Omit `month` to include students from every month (all students).
  month?: number;
  status?: BirthdayStatusFilter;
  format?: string;
}

export const reportingBirthdaysAPI = async ({
  month,
  status = 'all',
  format = 'csv',
}: ReportingBirthdaysParams) => {
  const response = await baseAPI.get<string>('reporting/birthdays', {
    params: {
      ...(month ? { month } : {}),
      ...(status && status !== 'all' ? { status } : {}),
      format,
    },
    responseType: 'text',
  });
  return response.data;
};

export const useReportingBirthdays = (params: ReportingBirthdaysParams) => {
  return useQuery({
    queryKey: [
      KEYS.BIRTHDAYS_REPORT,
      params.month,
      params.status,
      params.format,
    ],
    queryFn: () => reportingBirthdaysAPI(params),
    enabled: !!params.month,
  });
};
